/**
 * 消息相关API接口
 */
import request from '@/utils/request'
import type {
  Message,
  MessageStats,
  ApiResponse,
  PaginationParams,
  PaginationResponse
} from '@/types/models'

export const messageApi = {
  /**
   * 获取消息列表
   */
  getMessageList(params?: PaginationParams & { type?: string; isRead?: boolean }) {
    return request<ApiResponse<PaginationResponse<Message>>>({
      url: '/api2/messages',
      method: 'get',
      params
    })
  },

  /**
   * 获取消息详情
   */
  getMessageDetail(id: string) {
    return request<ApiResponse<Message>>({
      url: `/api2/messages/${id}`,
      method: 'get'
    })
  },

  /**
   * 获取消息统计
   */
  getMessageStats() {
    return request<ApiResponse<MessageStats>>({
      url: '/api2/messages/stats',
      method: 'get'
    })
  },

  /**
   * 标记消息为已读
   */
  markAsRead(ids: string | string[]) {
    return request<ApiResponse<void>>({
      url: '/api2/messages/read',
      method: 'post',
      data: {
        ids: Array.isArray(ids) ? ids : [ids]
      }
    })
  },

  /**
   * 标记所有消息为已读
   */
  markAllAsRead() {
    return request<ApiResponse<void>>({
      url: '/api2/messages/read-all',
      method: 'post'
    })
  },

  /**
   * 删除消息
   */
  deleteMessage(ids: string | string[]) {
    return request<ApiResponse<void>>({
      url: '/api2/messages',
      method: 'delete',
      data: {
        ids: Array.isArray(ids) ? ids : [ids]
      }
    })
  },

  /**
   * 清空消息
   */
  clearMessages(type?: string) {
    return request<ApiResponse<void>>({
      url: '/api2/messages/clear',
      method: 'post',
      data: { type }
    })
  }
}

export default messageApi